// src/components/Admin/TaskManager/index.tsx

import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper, Typography, Container } from '@mui/material';
import ScheduledTasksTab from './ScheduledTasksTab';
import JobExecutionsTab from './JobExecutionsTab';
import ExecutionHistoryTab from './ExecutionHistoryTab';
import QueueStatusPanel from './QueueStatusPanel';
import { useNavigate, useParams } from 'react-router-dom';
import { ADMIN_URL_TOOLBOX_CONFIG } from '../PageStructure/admin-values';

const TaskManager: React.FC = () => {

  const tabs = [
    'scheduled-tasks',
    'job-executions',
    'execution-history',
  ]
  const navigate = useNavigate();
  const { tab1 } = useParams();
  const activeTab = (tabs.includes(tab1)) ? tab1 : tabs[0];

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    navigate(`${ADMIN_URL_TOOLBOX_CONFIG}/queue/${newValue}`);
  };

  return (
    <Container maxWidth={false} sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom>
        Task Queue Management
      </Typography>

      <Typography variant="body2" color="text.secondary" paragraph>
        Manage scheduled tasks, monitor job executions, and view queue status
      </Typography>

      {/* Queue Status Overview */}
      <QueueStatusPanel />

      {/* Tab Navigation */}
      <Paper sx={{ mb: 2 }}>
        <Tabs value={activeTab} onChange={handleTabChange} variant="fullWidth">
          <Tab label="Scheduled Tasks" value={tabs[0]} />
          <Tab label="Job Executions" value={tabs[1]} />
          <Tab label="Execution History" value={tabs[2]} />
        </Tabs>
      </Paper>
      {/* Tab Content */}
      <Box>
        {activeTab === tabs[0] && <ScheduledTasksTab />}
        {activeTab === tabs[1] && <JobExecutionsTab />}
        {activeTab === tabs[2] && <ExecutionHistoryTab />}
      </Box>
    </Container>
  );
};

export default TaskManager;